import {styled as muiStyle, CSSObject, alpha} from '@mui/material/styles';
import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonProps as MuiToggleButtonProps,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';

export const StyledToggleButton = muiStyle(ToggleButton)<MuiToggleButtonProps>(({ theme,  color }:any):CSSObject => ({
}));


const variantMixin = ({ theme, variant, color }: any): CSSObject => ({
  ...(variant === `outlined` && {
    '.MuiButtonBase-root': {
      border: `1px solid`,
      '&.Mui-selected': {
        border: `1px solid `,
        borderColor: theme.palette[color].main,
        '&:not(:first-of-type)': {
          borderColor: theme.palette[color].main
        },
      },
    },
  }),
  ...(variant === `contained` && {
    '.MuiButtonBase-root': {
      color: theme.palette.text.secondary,
      '&.Mui-selected': {
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].main,
        borderColor: theme.palette[color].main,
        '&:hover': {
          color: theme.palette[color].contrastText,
          backgroundColor: theme.palette[color].main,
          borderColor: theme.palette[color].main,
        }
      }
    },
  }),
});

export const StyledToggleButtonGroup = muiStyle(ToggleButtonGroup)<MuiToggleButtonGroupProps>(
  ({ theme,variant, color }:any):CSSObject => ({
    '.MuiToggleButtonGroup-grouped': {
      height: `38px`,
      '&.MuiToggleButtonGroup-groupedHorizontal': {
        minWidth: `74px`,
      }
    },

    ...(color !== undefined &&
        color !== `inherit` && variant !== undefined && variantMixin({ theme, variant, color })),


  }),
);
